// extracted by mini-css-extract-plugin
export default {"product-details-tab":"ProductDetailsTab_product-details-tab__aAhd3","flag-icon":"ProductDetailsTab_flag-icon__nz1Vh"};